import store from '@/store'

// con este guard aplicamos una especie de middleware sobre la ruta
// para redireccionar si no esta logeado
const guest = (to, from, next) => {
    if(!store.getters['auth/authenticated']){
      return next({
        name: 'Login'
      })
    }
    next()
}

// con este guard aplicamos una especie de middleware sobre la ruta
// para redireccionar si ya esta logeado
const auth = (to, from, next) => {
    if(store.getters['auth/authenticated']){
      return next({
        path: '/'
      })
    }
    next()
}

export default {guest, auth}
